// The payload is wrapped in an object: synapse requires `payload` to be a record, never a primitive.
export type AiCostLimitDeletedPayload = {
	limitId: number;
};

export type AiCostLimitDeletedAction = {
	type: 'AI_COST_LIMIT_DELETED';
	payload: AiCostLimitDeletedPayload;
	accountId: number;
};

export default (payload: AiCostLimitDeletedPayload, accountId: number): AiCostLimitDeletedAction => ({
	type: 'AI_COST_LIMIT_DELETED',
	payload,
	accountId,
});
